export interface ProductCreative {
  id?: number;
  image_url?: string;
  format?: string;
}

export interface ProductInfoCreative {
  product_id: string;
  website_id: string;
  name: string;
  description: string;
  image_url?: string;
  creatives?: ProductCreative[];
}

export const productsInfoCreativeMock: ProductInfoCreative[] = [
  {
    product_id: "0526be67764e4404a47219a702a326b",
    website_id: "4827c8dfa5f94626bc6c19a702a7289",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/7afc648a/variation_c94e87af.webp"
  },
  {
    product_id: "0526be67764e4404a47219a702a326b",
    website_id: "40c1ae5dd04b4a9ea70d19a702a778b",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/7afc648a/variation_c94e87af.webp"
  },
  {
    product_id: "670a4d8599cb41d4b96819ae676e308",
    website_id: "ef4d79af09d24de2a68019ae676ee50",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/e3eaa237/variation_9f77d45a.webp"
  },
  {
    product_id: "670a4d8599cb41d4b96819ae676e308",
    website_id: "0ebd11113337485ba82119ae676f199",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/e3eaa237/variation_9f77d45a.webp"
  },
  {
    product_id: "8d031b09aba14928ba0e19ae679f64b",
    website_id: "a7a18ef5ee684cb5bea319ae67a1e76",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/f6dfbff6/variation_a613e819.webp"
  },
  {
    product_id: "6e201b699d834094a05419ae67c2123",
    website_id: "b8373e57d987437ba44619ae67c28f3",
    name: "Adidas superstart",
    description: "Blancos"
  },
  {
    product_id: "6e201b699d834094a05419ae67c2123",
    website_id: "f51595904397476aaba319ae67c4e20",
    name: "Adidas superstart",
    description: "Blancos",
    creatives: [
      {
        id: 1,
        image_url: "https://cdn.fluxi.com/creatives/imagen-anuncio.jpg"
      },
      {
        id: 2,
        image_url: "https://cdn.fluxi.com/creatives/imagens-anuncio.jpg"
      },
      {
        id: 3,
        image_url: "https://cdn.fluxi.com/creatives/imagens-anuncio.jpg"
      },
      {
        id: 4,
        image_url: "https://cdn.fluxi.com/creatives/imagens-anuncio.jpg",
        format: "1:1"
      }
    ]
  },
  {
    product_id: "987d86f225534f30ad3e19ae67f62c9",
    website_id: "81af42a4d405464e908f19ae67f6ff4",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/07630576/variation_9911063a.webp"
  },
  {
    product_id: "987d86f225534f30ad3e19ae67f62c9",
    website_id: "09e503ef735d4eb58a0c19ae67f6c2d",
    name: "Adidas superstart",
    description: "Blancos",
    image_url: "https://fluxi.co/dev/assets/acb3b1a65f744088868e19591057cd5/products/variations/07630576/variation_9911063a.webp"
  }
];

